module.exports = __webpack_public_path__ + "media/images/noimage-creator@3x-fa8ad84c2eb3f3af041d97be6cfdad71.png";